import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Resources from "@/pages/Resources";

export const Route = createFileRoute("/zh-cn/knowledge-center/")({
  head: () => buildRouteHead("/zh-cn/knowledge-center"),
  component: Resources,
});
